import { App, Spin } from 'antd';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PROJECT_REPORT_MERGE_NOTICE } from '@/constants/phase4-r-lite';
import { ROUTES } from '@/constants/routes';

interface ProjectReportSubmitRedirectPageProps {
  variant: 'leader' | 'employee';
}

export function ProjectReportSubmitRedirectPage({ variant }: ProjectReportSubmitRedirectPageProps) {
  const navigate = useNavigate();
  const { message } = App.useApp();

  useEffect(() => {
    message.info(PROJECT_REPORT_MERGE_NOTICE, 5);
    const target =
      variant === 'leader' ? ROUTES.mobile.leader.myReport : ROUTES.mobile.employee.reports;
    navigate(target, { replace: true });
  }, [message, navigate, variant]);

  return (
    <div className="mobile-card" style={{ textAlign: 'center', padding: 48 }}>
      <Spin tip="正在跳转…" />
    </div>
  );
}
